import {
    FILE_UPLOAD_UPLOADING,
    FILE_UPLOAD_DELETE
} from '../Actions/FileUpload.action';

const defaultState = {
    uploading: false,
    error: false,
};

export const fileUpload = (state = defaultState, action) => {
    switch (action.type) {
        case FILE_UPLOAD_UPLOADING:
        case FILE_UPLOAD_DELETE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};